export default [
  {
    path: '/ci/all',
    name: 'ci_all',
    component: () => import('./AllCi.vue'),
    meta: {
      pageSection: 'Comunicação interna',
      pageTitle: 'Lista de CI',
      auth: true,
      user: 'Admin',
    },
  },
]
